import Vue from 'vue'

function formatNumber(n) {
    n = n.toString()
    return n[1] ? n : '0' + n
}

//YY-MM
Vue.filter('formatTime_YY-MM', function(value) {
    var date = new Date(value);
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    return [ year,month].map(formatNumber).join('-');
});

Vue.filter('formatMoneySpace_0', function(value) {
    return value ? "¥ "+ parseFloat(value).toFixed(2) : '0';
});

//YYYY-MM-DD hh:mm:ss
Vue.filter('formatTime', function(value) {
	var date = new Date(parseInt(value));
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var minute = date.getMinutes();
    var second = date.getSeconds();
    return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':');
});

//YYYY-MM-DD hh:mm:ss
Vue.filter('formatTime2', function(value) {
	var date = new Date(parseInt(value));
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    return [year, month, day].map(formatNumber).join('.') ;
});


// WEBPACK FOOTER //
// ./src/assets/js/filter.js